// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/burger/burger-demo.scss
 ** module id = 52
 ** module chunks = 0 1
 **/